import EditButtons from 'Components/Atoms/EditButtons/EditButtons';
import TextItem from 'Components/Atoms/ExpandableItems/TextItem';
import TextItemInfo from 'Components/Atoms/ExpandableItems/TextItemInfo';
import TextItemLabel from 'Components/Atoms/ExpandableItems/TextItemLabel';
import { useEffect, useState } from 'react';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { prepareDualListBox } from 'Services/helpers';
import { createField } from 'Store/FieldManagement/Actions';
import { FieldType, FieldTypes, getFieldTypeLabel } from 'Store/FieldManagement/PropTypes';
import { getAllDatasets, getAllFields } from 'Store/FieldManagement/Selectors';
import Field from '../FieldTypes/Field';

const FieldAdd = (props: any) => {
    const [name, setName] = useState('');
    const [type, setType] = useState<FieldTypes>(FieldType.Text);
    const [defaultValue, setDefaultValue] = useState<any>();
    const [required, setRequired] = useState(false);

    useEffect(() => {
        switch (type) {
            case FieldType.Dropdown:
            case FieldType.Multi_Selector:
                setDefaultValue({
                    value: [],
                    dataset: []
                });
                break;
            case FieldType.Toggle:
                setDefaultValue(false);
                break;
            case FieldType.Text:
            default:
                setDefaultValue('');
        }
    }, [type]);

    const validate = () => {
        if (name === '') {
            alert('Please fill in every required field');
            return;
        }

        props.createField({
            name: name,
            type: type,
            default: defaultValue,
            required: required,
            entity: props.entity,
            is_public: false
        }).then(() => props.cancel());
    }

    return (
        <>
        <div className={'expandable-item'}>
            <div className={'expandable-item__wrapper'}>
                <div className={'expandable-item__name'}>
                    <Field type={FieldType.Text} isEdit={true} value={name} onChange={(value: any) => setName(value)} />
                </div>
                <TextItem hasBorder={true}>
                    <TextItemLabel>Type:</TextItemLabel>
                    <TextItemInfo>
                        <select onChange={(e: any) => setType(e.target.value)}>
                            {
                                Object.keys(FieldType).map((key: any) => {
                                    key = parseInt(key);
                                    if (isNaN(key)) {
                                        return;
                                    }
                                    
                                    return <option
                                        key={key}
                                        value={key}
                                    > { getFieldTypeLabel(key) } </option>
                                })
                            }
                        </select>
                    </TextItemInfo>
                </TextItem>
                <TextItem fullWidth={type != FieldType.Dropdown && type != FieldType.Multi_Selector && type != FieldType.Toggle}>
                    <TextItemLabel>Verplicht:</TextItemLabel>
                    <TextItemInfo>
                        <Field
                            isEdit={true}
                            value={required}
                            type={FieldType.Toggle}
                            onChange={(value: any) => setRequired(value)}
                        />
                    </TextItemInfo>
                </TextItem>

                {
                    (type == FieldType.Dropdown || type == FieldType.Multi_Selector) && 
                    <TextItem fullWidth>
                        <TextItemLabel>Default:</TextItemLabel>
                        <TextItemInfo>
                            <Field
                                isEdit={true}
                                value={defaultValue?.value}
                                type={FieldType.Dropdown}
                                required={false}
                                onChange={(value: any) => setDefaultValue({
                                    ...defaultValue,
                                    value: value
                                })}
                                fieldProperties={defaultValue}
                            />
                        </TextItemInfo>
                    </TextItem>
                }

                {
                    (type == FieldType.Dropdown || type == FieldType.Multi_Selector) &&
                    <TextItem fullWidth>
                        <TextItemLabel>Dataset:</TextItemLabel>
                        <TextItemInfo>
                            <Field
                                isEdit={true}
                                value={defaultValue?.dataset}
                                type={FieldType.Dropdown}
                                required={false}
                                onChange={(value: any) => setDefaultValue({
                                    ...defaultValue,
                                    dataset: value
                                })}
                                fieldProperties={{
                                    allowRoot: true,
                                    allowInternal: true,
                                    allowCustoms: true,
                                }}
                            />
                        </TextItemInfo>
                    </TextItem>
                }

                <div className={'expandable-item__toolbox'}>
                    <EditButtons
                        isEdit
                        onSave={() => validate()}
                        onCancel={() => props.cancel()}
                        onDeleteOpen={() => {}}
                        defaultEdit={true}
                    />
                </div>
            </div>
        </div>
        {
            type == FieldType.Combination && 
            <div style={{width: 'calc(100% - 72px)', marginLeft: 'auto'}}>
                <DualListBox
                    preserveSelectOrder
                    showOrderButtons
                    options={prepareDualListBox(props.fields[props.entity]?.saved.filter((item: any) => item.type != FieldType.Combination && item.status != 0))}
                    selected={defaultValue?.fields || []}
                    onChange={(value: any) => setDefaultValue({
                        ...defaultValue,
                        entity: props.entity,
                        fields: value
                    })}
                />
            </div>
        }
        </>
    )
}

export default connect(
    (state: any) => ({
        datasets: getAllDatasets(state),
        fields: getAllFields(state)
    }),
    {
        createField
    }
)(FieldAdd);